import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function FinalCTASection() {
  return <section id="contacto" className="py-32 bg-brand-beige/30 relative overflow-hidden" data-id="element-25" data-mp="3n1rxkh6jqdi8">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-white/60 blur-3xl rounded-full -z-10" data-id="element-26" data-mp="3s0bkajsyrtbn" />
      <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-brand-gold/25 rounded-full blur-3xl -z-10 animate-pulse-glow" data-id="element-27" data-mp="2ze0lneox42hh" />
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-brand-sage-light/30 rounded-full blur-3xl -z-10 animate-pulse-glow" style={{
      animationDelay: '2s'
    }} data-id="element-28" data-mp="34ddc09ezzrot" />

      {/* Floating Sparkles */}
      <motion.div className="absolute top-1/4 right-1/3 text-brand-gold/60 animate-float" data-id="element-29" data-mp="3e47tz1l7o54g">
        <Sparkles size={32} data-id="element-30" data-mp="2gl6irj4kk0tm" />
      </motion.div>
      <motion.div className="absolute bottom-1/3 left-1/4 text-brand-sage/50 animate-float" style={{
      animationDelay: '1.5s'
    }} data-id="element-31" data-mp="2ll2bgm7tg5tv">
        <Sparkles size={24} data-id="element-32" data-mp="21w7lz91v5935" />
      </motion.div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-33" data-mp="21wfzn35t8ife">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto text-center" data-id="element-34" data-mp="1x4fqql7rif6o">
          <h2 className="text-5xl md:text-6xl font-serif text-brand-charcoal mb-6 leading-tight" data-id="element-35" data-mp="1e6d6ejq5t6f7">
            Tu piel puede cambiar…
          </h2>

          <p className="text-xl text-brand-charcoal/70 mb-12 font-light" data-id="element-36" data-mp="198k1rv4i8kh1">
            Da el primer paso hoy. Estoy aquí para acompañarte en tu proceso 🧚🏻
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-37" data-mp="33l1lisq4x2gx">
            <a href="https://mall.riman.com/nicolcabello/products/54828?Concern=87,93,94&Line=133&SubCategory=100&Category=5,2" target="_blank" rel="noopener noreferrer" className="btn-sparkle w-full sm:w-auto px-10 py-5 bg-brand-sage text-white rounded-full font-medium text-lg hover:bg-brand-sage-dark transition-all transform hover:-translate-y-1 shadow-lg shadow-brand-sage/20 soft-glow-hover" data-id="element-38" data-mp="11vlye933rj8c">
              Quiero mi Ritual
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}